// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // API_URL: 'http://localhost:8000/',
  API_URL: 'https://api.postulatembs.com/',
  events_course_ctg: '12',
  internship_course_ctg: '14',
  Domain_URL: 'https://postulatembs.com/',
  PINCODE_URL: 'https://api.postalpincode.in/pincode/',

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {
    apiKey: "AIzaSyDJrFo3P3H3ykHCST7HYyAXMRRlGARX-1E",
    authDomain: "postulateerp.firebaseapp.com",
    projectId: "postulateerp",
    storageBucket: "postulateerp.firebasestorage.app",
    messagingSenderId: "383344211756",
    appId: "1:383344211756:web:3a029eb09d6b7cd1c59e89",
    measurementId: "G-ZR62VKLT09",
    vapidKey: "BFO0WDfNE7CGxuK0smdfeqgKvNWtT9HF2VXQPcBQLXNaWqz91yTUfx6XqRZv17v4b-7j7KWENJQCAma1bpNjC-0"

  },
  firebase_vapidKey:
    'BJfkgAhovUbjnTwDwKUH2NzTQdHhZc0BElPrctFdBwrar0NFvAkbuMVfJRGbgSkJpWSva0bZGVCg3StTRYx2uaU',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
